import React, { useState, useEffect } from "react";
import { useHardCode } from "../../hooks";
import { useSelector, useDispatch } from "react-redux";
import { setProductDetails } from "../../redux/slices";
import { productActionTypes } from "../../redux/utils";
import { countries, country_state } from "../../Utilities";

import "./contactInfoModal.css";
export const ContactInfoModal = ({ onRequestClose }) => {
  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const initialValues = {
    email: productDetailsState?.customerInfo?.customer_email,
    phone: productDetailsState?.customerInfo?.customer_contact,
    addressLine1: productDetailsState?.customerInfo?.customer_address1,
    addressLine2: productDetailsState?.customerInfo?.customer_address2,
    city: productDetailsState?.customerInfo?.customer_city,
    state: productDetailsState?.customerInfo?.customer_state,
    state_code: productDetailsState?.customerInfo?.customer_state_code,
    pincode: productDetailsState?.customerInfo?.customer_zip,
    country: productDetailsState?.customerInfo?.country_name,
    country_code: productDetailsState?.customerInfo?.country_code,
  };
  const [values, setValues] = useState(initialValues);
  const [selectedCountry, setSelectedCountry] = useState(initialValues.country);
  const [selectedCountryCode, setSelectedCountryCode] = useState(
    initialValues.country_code
  );
  const [selectedState, setSelectedState] = useState(initialValues.state);
  const [selectedStateCode, setSelectedStateCode] = useState(
    initialValues.state_code
  );
  const [errorMsg, setErrorMsg] = useState(
    storeConfigState?.themeConfig?.incomplete_address
  );
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const dispatch = useDispatch();
  useEffect(() => {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the modal when the Escape key is pressed
        onRequestClose();
      }
    }
    // Prevent scrolling
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = "visible";
      document.removeEventListener("keydown", onKeyDown);
    };
  });
  const handleInputChange = (e) => {
    const { name, value, selectedIndex } = e.target;
    if (
      name === "country_code" ||
      name === "state_code" ||
      name === "country" ||
      name === "state"
    ) {
      let selectedText = e?.target[selectedIndex]?.text;
      if (name === "country_code") {
        setSelectedCountry(selectedText);
        setSelectedCountryCode(value);
        values.addressLine1 = "";
        values.city = "";
        values.state = "";
        values.state_code = "";
        values.pincode = "";
        setIsBtnDisabled(true);
        setSelectedState("");
        setSelectedStateCode("");
      } else {
        if (name === "state_code") {
          setSelectedState(selectedText);
          setSelectedStateCode(value);
        } else if (name === "state") {
          setSelectedState(value);
        }
      }
    } else {
      if (
        values.addressLine1 !== "" &&
        values.city !== "" &&
        values.state !== "" &&
        values.pincode !== ""
      ) {
        setIsBtnDisabled(false);
      } else {
        setIsBtnDisabled(true);
      }
    }
    setValues({
      ...values,
      [name]: value,
    });
  };

  const isStorePureFemale =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const CONTACT_INFORMATION = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.contact_information
    : storeConfigState?.themeConfig?.shipping_information;
  const FROM_ADDRESS = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.from_address
    : "";
  const SAVE = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.save
    : storeConfigState?.themeConfig?.save;
  const CANCEL = isStorePureFemale
    ? PURE_FEMALE_TRANSLATION.review.cancel
    : storeConfigState?.themeConfig?.cancel;

  const saveAddress = () => {
    const customerInfo = {
      customer_address1:
        values.addressLine1 ||
        productDetailsState?.customerInfo?.customer_address1,
      customer_address2:
        values.addressLine2 ||
        productDetailsState?.customerInfo?.customer_address2,
      customer_zip:
        values.pincode || productDetailsState?.customerInfo?.customer_zip,
      customer_city:
        values.city || productDetailsState?.customerInfo?.customer_city,
      customer_state: selectedState,
      customer_state_code: selectedStateCode,
      country_name: selectedCountry,
      country_code: selectedCountryCode,
      customer_contact:
        values.phone || productDetailsState?.customerInfo?.customer_contact,
      customer_email:
        values.email || productDetailsState?.customerInfo?.customer_email,
    };
    dispatch(
      setProductDetails({
        key: productActionTypes.UPDATE_CUSTOMER_INFO,
        value: customerInfo,
      })
    );
    onRequestClose();
  };

  useEffect(() => {
    if (
      values.addressLine1 !== "" &&
      values.city !== "" &&
      (values.state !== "" ||
        (selectedState !== "" && values.state_code !== "")) &&
      values.pincode !== ""
    ) {
      setIsBtnDisabled(false);
    } else {
      setIsBtnDisabled(true);
    }
  }, [values]);

  return (
    <div className="saara-contact-info" id="contact-info">
      <div className="saara-contact-info-content">
        <div className="saara-contact-info-close-icon">
          <img
            onClick={onRequestClose}
            src="assets/svg/close.svg"
            alt="close"
            className="saara-close-icon"
          />
        </div>
        <div className="contact-info-input-main">
          <div className="contact-info-input">
            <div className="contact-info-input-heading">
              {CONTACT_INFORMATION}
            </div>
            {isBtnDisabled && <div className="modal-error-msg">{errorMsg}</div>}
            <div className="saara-contact-info-input-box">
              <input
                type="email"
                placeholder={storeConfigState?.themeConfig?.email}
                className="saara-modal-email"
                value={values.email}
                onChange={handleInputChange}
                name="email"
              />
              <input
                type="text"
                placeholder={storeConfigState?.themeConfig?.phone}
                className="saara-modal-phone"
                value={values.phone}
                onChange={handleInputChange}
                name="phone"
              />
            </div>
          </div>
          <div className="from-address-main">
            <div className="from-address-heading">{FROM_ADDRESS}</div>
            <div className="from-address-content-1">
              <input
                type="text"
                placeholder={storeConfigState?.themeConfig?.address_line_1}
                className="saara-detail-address saara-add-1"
                value={values.addressLine1}
                onChange={handleInputChange}
                name="addressLine1"
              />
              <input
                type="text"
                placeholder={storeConfigState?.themeConfig?.address_line_2}
                className="saara-detail-address saara-add-2"
                value={values.addressLine2}
                onChange={handleInputChange}
                name="addressLine2"
              />
            </div>
            <input
              type="hidden"
              className="country-list saara-detail-address-2"
              value={selectedCountry}
              onChange={handleInputChange}
              name="country"
              disabled
            />
            <div class="from-address-content-1">
              <select
                id="country"
                name="country_code"
                className="country-list saara-detail-address saara-add-2"
                onChange={handleInputChange}
                defaultValue={selectedCountryCode}
              >
                {countries?.map((country) => {
                  return (
                    <>
                      <option value={country.code} key={country.code}>
                        {country.name}
                      </option>
                    </>
                  );
                })}
              </select>
            </div>
            <div className="saara-from-address-content-2">
              {(selectedCountryCode === "US" ||
                selectedCountryCode === "AU" ||
                selectedCountryCode === "IN") && (
                <select
                  id="country-state"
                  className="state-list"
                  onChange={handleInputChange}
                  name="state_code"
                  defaultValue={selectedStateCode}
                >
                  <option value="">Select State</option>
                  {country_state[selectedCountryCode]?.map((state) => {
                    return (
                      <option value={state.code} key={state.code}>
                        {state.name}
                      </option>
                    );
                  })}
                </select>
              )}

              <input
                type={
                  selectedCountryCode === "US" ||
                  selectedCountryCode === "AU" ||
                  selectedCountryCode === "IN"
                    ? "hidden"
                    : "text"
                }
                placeholder={storeConfigState?.themeConfig?.enter_state}
                className="saara-detail-address-2"
                value={values.state || selectedState}
                onChange={handleInputChange}
                name="state"
              />

              <input
                type="text"
                placeholder={storeConfigState?.themeConfig?.city}
                className="saara-detail-address-2"
                value={values.city}
                onChange={handleInputChange}
                name="city"
              />

              <input
                type="text"
                placeholder={storeConfigState?.themeConfig?.zip_code}
                className="saara-detail-address-2"
                value={values.pincode}
                onChange={handleInputChange}
                name="pincode"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="saara-contact-info-btns">
        <div className="saara_btn__big_screen_new margin-right-20">
          <button
            className="saara_custom_btn btn__back saara_modal_button_back"
            onClick={onRequestClose}
          >
            {CANCEL}
          </button>
          <button
            onClick={saveAddress}
            disabled={isBtnDisabled}
            className={`${
              isBtnDisabled
                ? "modal__btn__disabled"
                : "saara_custom_btn btn__submit saara_modal_button_submit"
            }`}
          >
            {SAVE}
          </button>
        </div>
      </div>
    </div>
  );
};
